import isInstanceReduxUtil from '../is-instance'

/**
 * Checks whether or not the given `value` is a pointer.
 * @param   {Object}  value
 * @returns {Boolean}
 */
function isPointerReduxUtil (value) {
  return (
    value &&
    !isInstanceReduxUtil(value) &&
    typeof value.className !==
    'undefined' &&
    typeof value.data !==
    'undefined'
  )
}

export default isPointerReduxUtil
